export default {
  timesheets: {
    absencesOverrides: 101392, // Absences & Overrides
    accrual: 90507, // Accrual
    addAbsencesAndOverrides: 102218, // Add Absences & Overrides
    addAnExpense: 102232, // Add an expense
    addExpense: 100740, // Add Expense
    addExpenses: 102237, // Add expenses
    addMoreExpenses: 102233, // Add more expenses
    addQuickEntry: 102217, // Add Quick Entry
    addTime: 95004, // Add Time
    approve: 95301, // Approve
    approveTimesheet: 102242, // Approve Timesheet
    approveTimesheetForThisEmployee: 102245, // Approve Timesheet for this employee
    approved: 81630, // Approved
    breakdownBy: 102254, // Breakdown by
    copyLastWeek: 91879, // Copy Last Week
    department: 95808, // Department
    departments: 28026, // Departments
    editExpenses: 102238, // Edit Expenses
    employeeIsNotATimesheetEmployee: 102240, // Employee is not a Timesheet employee
    exMeal: 102219, // Ex. Meal
    expense: 95374, // Expense
    expenses: 81619, // Expenses
    extraTime: 102241, // Extra time
    goToTimesheet: 102224, // Go to Timesheet
    noEntriesToShowForNow: 102223, // No entries to show for now
    noEntriesYet: 102222, // No entries yet!
    payPeriod: 100733, // Pay Period
    pendingSignoff: 102301, // Pending Signoff
    premium: 45565, // Premium
    quickEntry: 102220, // Quick Entry
    rejectTimesheet: 102250, // Reject Timesheet
    rejected: 91922, // Rejected
    scheduledAbsenceIsIgnoredOnTheStatDay: 102235, // Scheduled absence is ignored on the stat day
    selectPeriod: 101777, // Select Period
    showByWeeks: 102209, // Show by weeks
    showLessPeriods: 102251, // Show Less Periods
    showMorePeriods: 102252, // Show More Periods
    signOffOnTheEmployeesPayPeriod: 102249, // Sign off on the employee's pay period
    signOffTimesheet: 102248, // Sign off Timesheet
    signedOff: 102300, // Signed Off
    submitToSupervisor: 81631, // Submit to Supervisor
    timeCategory: 91520, // Time Category
    timesheet: 28087, // Timesheet
    timesheetRejectedByAdminUpdateTheTimesheetAndSubmitAgain: 102214, // Timesheet rejected by admin: update the timesheet and submit again
    timesheetSignedOffBySignedoffbyOnDate: 102247, // Timesheet signed off by {signedOffBy} on {date}
    timesheetSignoff: 81523, // Timesheet Signoff
    timesheetSignoffs: 102206, // Timesheet Signoffs
    toAddHoursToThisDateSelectTheRightPay: 102234, // To add hours to this date, select the right pay period
    todaysEntries: 102221, // Today's entries
    totalExpenses: 102239, // Total expenses
    totalHours: 81607, // Total Hours
    unsignedOnly: 101780, // Unsigned Only
    viewPayPeriodForThisEmployee: 102244, // View pay period for this employee
    viewTimesheet: 102243, // View Timesheet
    weeklyTotals: 91873, // Weekly Totals
    youAreAboutToSignOffOnThePeriodFor: 102246, // You are about to sign off on the period for {employee}
    youHaveSuccessfullyApprovedATimesheet: 102208, // You have successfully approved a timesheet
    youHaveSuccessfullyApprovedTheTimesheet: 102227, // You have successfully approved the timesheet
    youHaveSuccessfullyAuthorizedExtraTime: 102229, // You have successfully authorized extra time
    youHaveSuccessfullyCopiedLastWeek: 102225, // You have successfully copied last week
    youHaveSuccessfullyRejectedExtraTime: 102230, // You have successfully rejected extra time
    youHaveSuccessfullyRejectedTheTimesheet: 102228, // You have successfully rejected the timesheet
    youHaveSuccessfullySavedAnEntry: 102216, // You have successfully saved an entry
    youHaveSuccessfullySavedTheTimesheet: 102226, // You have successfully saved the timesheet
    youHaveSuccessfullySignedOffOnAPeriod: 102207, // You have successfully signed off on a period
    youHaveSuccessfullySubmittedTheTimesheet: 102213, // You have successfully submitted the timesheet
  },
};
